module.exports = __webpack_public_path__ + "img/image2.c14f1e8d.png";